import React from 'react';
import { selectChangeSla } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/select-change-sla';
import { getDisplayOptionTextForValue } from 'AppSrc/core/components/forms/data/display-option-lookup-utils';
import { selectNetworkParams } from 'AppSrc/core/components/forms/form-types/create-crq/section-one/select-network-params';
import {
  CRQ_STATUS_DISPLAY_NAMES,
  getStatusValueForParameter,
  isStatusImplementation,
  isStatusCompleted,
} from 'AppSrc/core/crq/crq-statuses';
import { RowItem } from 'AppSrc/core/components/tables/row-item';
import { ChevronIconRight } from 'AppSrc/core/components/common/svg-icons';
import moment from 'moment';

// utils for displaying CRQ tables
// specific lookup functions for common fields in tables
const getTimingTextForValue = (network, value) => {
  const fieldId = `${selectChangeSla.id}-${network}`;
  return getDisplayOptionTextForValue(fieldId, value);
};

const getNetworkTextForValue = (value) => {
  const fieldId = selectNetworkParams.id;
  return getDisplayOptionTextForValue(fieldId, value);
};

const getDateDisplay = (date) => (date ? moment(date).format('DD/MM/YYYY') : '');


const getStageNameForStatus = (status, network) => {
  const statusValue = getStatusValueForParameter(status, network);
  return CRQ_STATUS_DISPLAY_NAMES[statusValue];
};


const getRowItem = (params) => {
  const {
    columnId,
    displayText,
    withChevron = false,
  } = params;
  const content = withChevron ? (
    <>
      <span className="table-row-with-chevron-text">{displayText}</span>
      <div className="table-row-chevron">
        <ChevronIconRight />
      </div>
    </>
  ) : displayText;
  return (
    <RowItem
      key={columnId}
      columnId={columnId}
    >
      {content}
    </RowItem>
  );
};

// return a row id for a row, that can be used as a path for
// view crq when clicking on the row
const getCrqListRowId = (network, crqId) => `${network}/${crqId}`;

// return a react key for a crq list row
// we cannot rely on crqId being unique from TIL-sim
// so we make an explicit key that includes the index
// NB: this is the index of the data retrieved from the server
// so it won't cause unecessary rerender on sort or filter
const getCrqListRowKey = (crqId, rowIndexFromServer) => `${crqId}:${rowIndexFromServer}`;

const getTimeLeft = (status, endDate, network, actionType) => {
  const statusValue = getStatusValueForParameter(status, network);
  const isEndDatePast = moment(endDate).diff() < 0;
  const now = new Date();


  if (
    actionType === 'completion review'
    && isStatusImplementation(statusValue)
    && isEndDatePast
  ) {
    return moment(endDate).add(12, 'h').diff(now, 'h') || 0;
  }
  if (
    actionType === 'failure review'
    && isStatusCompleted(statusValue)
    && isEndDatePast
  ) {
    return moment(endDate).add(72, 'h').diff(now, 'h') || 0;
  }
  return 0;
};

export {
  getTimingTextForValue,
  getNetworkTextForValue,
  getDateDisplay,
  getStageNameForStatus,
  getRowItem,
  getCrqListRowId,
  getCrqListRowKey,
  getTimeLeft,
};

